import { boolParam, enumParam, groupParam, intParam, stringParam } from './urlState'
import type { DefaultEventCategory } from '@/types'

export const CAMERAS_SCHEMA = {
  q: stringParam(''),
  group: groupParam(),
  ingestion: enumParam(['all', 'http', 'ftp'] as const, 'all'),
  online: enumParam(['all', 'online', 'offline', 'unknown'] as const, 'all'),
  battery_low: boolParam(false),
}

const EVENTS_BASE = {
  camera: intParam(null),
  event_type: stringParam('all'),
  media_type: stringParam('all'),
  detected_object: stringParam('all'),
  start_date: stringParam(''),
  end_date: stringParam(''),
  event: intParam(null), // lightbox deep link
}

// #392 — 'critical' is a tab of the URL only (?category=critical: shareable, survives a reload). It is NOT a
// DefaultEventCategory: the fleet-wide default tab is also read by the mobile app.
// #406 — 'suspicious' the same: a tab of the URL only, between All and Critical.
const EVENT_CATEGORIES = ['animal', 'human', 'other', 'all', 'suspicious', 'critical'] as const

/** /events — includes the Animal/Human/Other/All/Suspicious/Critical tab. #248: the tab a bare URL opens on is the
 * fleet-wide setting a super admin chooses, so the schema is built per value (EventsPage fetches
 * it, EventFeed memoises the schema). An explicit ?category= always wins; the default is never
 * written into the URL. */
export function eventsSchema(defaultCategory: DefaultEventCategory) {
  return {
    ...EVENTS_BASE,
    category: enumParam(EVENT_CATEGORIES, defaultCategory),
    unread: boolParam(false), // #292 — "Unread only" (the dashboard's Recent Events card link)
    hide_motion: boolParam(false), // #304 — motion-only events left out (the same card's link)
  }
}
export type EventsSchema = ReturnType<typeof eventsSchema>

/** /favourites — FavouritesPage passes showCategoryTabs={false}, so no tab param. */
export const EVENTS_SCHEMA_NO_CATEGORY = EVENTS_BASE

export const ALL_CAMERAS_SCHEMA = {
  q: stringParam(''),
  owner: stringParam('all'),
}
